import React from "react";
import { useTranslation } from "react-i18next";

import { Container, Button } from "./style";

const PreSale = () => {
  const [t, i18n] = useTranslation("global");
  const lenguageCss = i18n.languages[0];

  return (
    <Container style={{ backgroundColor: "#27292a" }}>
      <h1>{t("titlePreSale.titlePreSale")}</h1>
      <p>{t("textPreSale.textPreSale")}</p>
      <Button lenguageCss={lenguageCss} href="#contact">
        {t("buttonPreSale.buttonPreSale")}
      </Button>
    </Container>
  );
};

export default PreSale;
